<template>


  <div class="select-categories-section ">

    <p v-if="selectedCategory">دسته بندی: <span class="btn btn-primary rounded-pill">{{
        selectedCategory.title
      }}</span></p>

    <div v-if="isSelectCategoryValid">
      <div class="form-group">
        <input type="text" placeholder="جست و جو" class="form-control" v-model="searchWord">
      </div>

      <div class="" v-if="searchWord.length>0">
        <div class="category-item " v-for="category in filterCategories"
             @click="setSelectedCategory(category)">
          {{ category.title }}
        </div>
      </div>
      <div class="" v-else>
        <p>دسته خود را جست وجو کنید</p>
      </div>

    </div>

    <div v-else>
      <p>تغییر دسته بندی در دسترس نمیباشد.</p>
    </div>
  </div>

</template>

<script>
export default {
  name: "BasalamCategories",
  props: {
    defaultCategory: {
      default: null
    },
    basalamProduct: {
      default: null
    }
  },
  data() {
    return {
      categories: [],
      searchWord: "",
      selectedCategory: null,
    };
  },
  computed: {
    filterCategories() {
      let filteredCategories = this.categories.slice(); // Make a copy of the categories array

      function deepSearchCategory(categories, searchTerm, resultList = []) {
        // Base case: if categories is not an array or is empty, return null
        if (!Array.isArray(categories) || categories.length === 0) {
          return resultList;
        }

        // Iterate through each category in the current level
        for (let category of categories) {
          // Check if the current category's title matches the search term
          if (category.title.indexOf(searchTerm) > -1 && category.children.length == 0) {
            // If it's a match, add it to the resultList
            resultList.push(category);
          }

          // If the current category has children, recursively search within them
          if (category.children && category.children.length > 0) {
            deepSearchCategory(category.children, searchTerm, resultList);
          }
        }

        return resultList;
      }


      // If searchWord is not empty, filter the categories
      if (this.searchWord.trim() !== "") {
        filteredCategories = deepSearchCategory(this.categories, this.searchWord)
      }

      return filteredCategories;
    },
    isSelectCategoryValid() {
      return this.basalamProduct == null ? true : this.basalamProduct.allow_category_change
    }
  },
  methods: {
    setSelectedCategory(category) {
      this.selectedCategory = category
      this.$emit('category', category)
    }
  },
  async mounted() {
    this.categories = await this.$store.dispatch("Basalam/getCategories");
    if (this.defaultCategory != null) {
      this.selectedCategory = this.defaultCategory
    }
  },
  watch: {
    defaultCategory: {
      async handler(newValue, oldValue) {
        if (newValue != null) {
          this.selectedCategory = this.defaultCategory;
        }
      },
      deep: false
    }
  }
};
</script>

<style scoped>
.select-categories-section {
  background: lightblue;
  padding: 10px;
  border-radius: 10px;
  height: 350px;
  overflow-y: auto;
}
</style>
